import * as amazoneInterface from './lib/amazone/amazone.i';
import * as documentInterface from './lib/document/document.i';
import * as evaluationInterface from './lib/session/evaluation/evaluation.i';
import * as satisfactionInterface from './lib/satisfaction/satisfaction.i';
import * as sessionPresenceInterface from './lib/session/presence/presence';
import * as sessionConsigneInterface from './lib/session/consigne/consigne.i';
import * as selectorInterface from './lib/selector/selector.i';
import * as contactInterface from './lib/contact/contact.i';
import * as contactClass from './lib/contact/contact';
import * as dureeInterface from './lib/duree/duree.i';
import * as dureeClass from './lib/duree/duree';
import * as domInterface from './lib/domain/domain.i';
import * as domClass from './lib/domain/domain';
import * as formInterface from './lib/formation/formation.i';
import * as formEnum from './lib/formation/formation.e';
import * as formClass from './lib/formation/formation';
import * as modaliteInterface from './lib/modalite/modalite.i';
import * as modaliteClass from './lib/modalite/modalite';
import * as resaInterface from './lib/resa/resa.i';
import * as resaClass from './lib/resa/resa';
import * as searchInterface from './lib/search/search.i';
import * as searchClass from './lib/search/search';
import * as sessionInterface from './lib/session/session.i';
import * as sessionPlanningInterface from './lib/session/planning/planning.i';
import * as sessionClass from './lib/session/session';
import * as siteInterface from './lib/site/site.i';
import * as siteClass from './lib/site/site';
import * as staticClientInterface from './lib/static/static-client/static-client.i';
import * as staticInterInterface from './lib/static/static-inter/static-inter.i';
import * as staticInterClass from './lib/static/static-inter/static-inter';
import * as statticFilterClass from './lib/static/static-filter/static-filter';
import * as staticFilterInerface from './lib/static/static-filter/static-filter.i';
import * as statticFilterEnum from './lib/static/static.e';
import * as userEnum from './lib/user/user.e';
import * as userInterface from './lib/user/user.i';
import * as userClass from './lib/user/user';
import * as gridState from './lib/grid-state/grid-state.i';

export namespace MContact {
  export import IContactOverview = contactInterface.IContactOverview;
  export import CContactOverview = contactClass.CContactOverview;
}

export namespace MDomain {
  export import IDomain = domInterface.IDomain;
  export import CDomain = domClass.CDomain;
}

export namespace MDuree {
  export import IDuree = dureeInterface.IDuree;
  export import CDuree = dureeClass.CDuree;
}

export namespace MFormation {
  export import IFormationInfo = formInterface.IFormationInfo;
  export import IFormInfo = formInterface.IFormInfo;
  export import CFormInfo = formClass.CFormInfo;
  export import IFormInfoDetails = formInterface.IFormInfoDetails;
  export import CFormInfoDetails = formClass.CFormInfoDetails;
  export import IFormInfoFocus = formInterface.IFormInfoFocus;
  export import CFormInfoFocus = formClass.CFormInfoFocus;
  export import IFormInfoInscript = formInterface.IFormInfoInscript;
  export import CFormInfoInscript = formClass.CFormInfoInscript;
  export import IFormOverview = formInterface.IFormOverview;
  export import CFormOverview = formClass.CFormOverview;
  export import IModaliteInfo = formInterface.IModaliteInfo;
  export import CModaliteInfo = formClass.CModaliteInfo;
  export import IFormOption = formInterface.IFormOption;
  export import CFormOption = formClass.CFormOption;
  export import IFormSearchParams = formInterface.IFormSearchParams;
  export import IOptionInfo = formInterface.IOptionInfo;
  export import COptionInfo = formClass.COptionInfo;
  export import EModa = formEnum.EModa;
}

export namespace MModalite {
  export import IModalite = modaliteInterface.IModalite;
  export import IValue = modaliteInterface.IValue;
  export import CModalite = modaliteClass.CModalite;
}

export namespace MResa {
  export import IResa = resaInterface.IResa;
  export import CResa = resaClass.CResa;
}

export namespace MSearch {
  export import ISearchResult = searchInterface.ISearchResult;
  export import CSearchResult = searchClass.CSearchResult;
}

export namespace MSession {
  export import ISessionInfo = sessionInterface.ISessionInfo;
  export import CSessionInfo = sessionClass.CSessionInfo;
  export import IPlanning = sessionPlanningInterface.IPlanning;
  export import IConsigne = sessionConsigneInterface.IConsigne;
  export import IPresence = sessionPresenceInterface.IPresence;
  export import ISessionApprenantPlanification = sessionPresenceInterface.ISessionApprenantPlanification;
  export import IEvaluation = evaluationInterface.IEvaluation;
  export import ISessionApprenantCompetences = evaluationInterface.ISessionApprenantCompetences;
}

export namespace MSite {
  export import IFormSite = siteInterface.IFormSite;
  export import CFormSite = siteClass.CFormSite;
}

export namespace MUser {
  export import ETypeUser = userEnum.ETypeUser;
  export import EAccessState = userEnum.EAccessState;
  export import IUser = userInterface.IUser;
  export import CUser = userClass.CUser;
  export import IUserAccess = userInterface.IUserAccess;
  export import CUserAccess = userClass.CUserAccess;
  export import IClient = userInterface.IClient;
  export import CClient = userClass.CClient;
  export import IContact = userInterface.IContact;
  export import CContact = userClass.CContact;
  export import IAddress = userInterface.IAddress;
  export import CAddress = userClass.CAddress;
}
export namespace MStaticClient {
  export import IStaticClientInfo = staticClientInterface.IStaticClientInfo;
  export import IStaticClientRequest = staticClientInterface.IStaticClientRequest;
  export import INbAbsent = staticClientInterface.INbAbsent;
  export import ICardVisualisationClient = staticClientInterface.ICardVisualisationClient;
}
export namespace MStaticInter {
  export import AStaticRequest = staticInterInterface.AStaticRequest;
  export import AStatistiqueCardVisualisation = staticInterInterface.AStatistiqueCardVisualisation;
  export import CDataApp = staticInterClass.DataApp;
  export import CCa = staticInterClass.Ca;
  export import ICa = staticInterInterface.ICa;
  export import IStaticInterRequest = staticInterInterface.IStaticInterRequest;
  export import IStaticInterInfo = staticInterInterface.IStaticInterInfo;
  export import IIndispoInterv = staticInterInterface.IIndispoInterv;
  export import IDataApp = staticInterInterface.IDataApp;
  export import IStatistiqueCardVisualisationInter = staticInterInterface.IStatistiqueCardVisualisationInter;
}

export namespace MStaticFilter {
  export import IDateSetPeriod = staticFilterInerface.IDateSetPeriod;
  export import ECode = statticFilterEnum.ECode;
  export import CPeriod = statticFilterClass.CPeriod;
}
export namespace MSelector {
  export import ASelector = selectorInterface.ASelector;
  export import IFamile_Group_Site = selectorInterface.IFamile_Group_Site;
  export import IPeriod = selectorInterface.IPeriod;
  export import IProduit = selectorInterface.IProduit;
  export import ISector = selectorInterface.ISector;
  export import IPays = selectorInterface.IPays;
  export import IStatut_Session = selectorInterface.IStatut_Session;
  export import ITypeApprenantSelector = selectorInterface.ITypeApprenantSelector;
  export import IIntervenantDepartementsSelector = selectorInterface.IIntervenantDepartementsSelector;
  export import IMotifAbsenceSelector = selectorInterface.IMotifAbsenceSelector;
}
export namespace MSatisfaction {
  export import ISatisfactionDefault = satisfactionInterface.ISatisfactionDefault;
  export import ISatisfactionOptinal = satisfactionInterface.ISatisfactionOptional;
  export import ISatisfactionUpdate = satisfactionInterface.ISatisfactionUpdate;
  export import ISatisfactionDefaultParms = satisfactionInterface.ISatisfactionDefaultParms;
}

export namespace MDocument {
  export import IDocumentPresignedResponse = documentInterface.IDocumentPresignedResponse;
  export import IDocumentInfo = documentInterface.IDocumentInfo;
}
export namespace MAmzone {
  export import IAmazoneUploadReponse = amazoneInterface.IAmazoneUploadReponse;
}
export namespace MGridSettings {
  export import IGridSettings = gridState.GridSettings;
}
